import React, { Component } from 'react';
import {isMobile} from "react-device-detect";

const DealsContext = React.createContext( {

});
class Deals extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
        this.handleCopyClick = this.handleCopyClick.bind(this);
    }

    handleCopyClick(code,copy_text_id) {
        $('.coupon-copy').each(function () {
            $(this).attr('hidden', true);
        });

        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(code).select();
        document.execCommand("copy");
        $temp.remove();

        $(`#${copy_text_id}`).attr('hidden', false);
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className={"mt-3"}>
                {
                    session.store.show_deal_carousel ?
                    <div id="carouselExampleControls" className="carousel slide mb-2" data-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <img src="https://placehold.it/1000x250" className="d-block w-100" alt="carousel1" />
                            </div>
                            <div className="carousel-item">
                                <img src="https://placehold.it/1000x250" className="d-block w-100" alt="carousel2" />
                            </div>
                            <div className="carousel-item">
                                <img src="https://placehold.it/1000x250" className="d-block w-100" alt="carousel3" />
                            </div>
                        </div>
                        <a className="carousel-control-prev" href="#carouselDeals" role="button"
                           data-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="sr-only">Previous</span>
                        </a>
                        <a className="carousel-control-next" href="#carouselDeals" role="button"
                           data-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="sr-only">Next</span>
                        </a>
                    </div>
                    :
                    <h2 className={'m-2'}>{window.session.store.deal_header_title || 'Our Deals'}</h2>
                }
                <div className={isMobile ? 'row m-1' : 'row'}>
                {
                    window.session.deals.length > 0 &&
                    window.session.deals.map((deal,i) => {
                        return(
                            <div className={isMobile ? 'col-12' : 'col-6'}>
                                <li className="media mb-2" key={i}>
                                    <img src={deal.img_src} width={deal.img_width} height={deal.img_height} className="mr-3" alt="Img Not Available" />
                                    <div className="media-body">
                                        <h5 className="mt-0 mb-1">{deal.deal_title}</h5>
                                        {deal.deal_text}
                                        <br/>
                                        <b>{deal.subtext}</b>
                                        &nbsp;<i className={"fa fa-copy text-branded"} onClick={() => {this.handleCopyClick(deal.code,`copy-${i}`)}}></i>
                                        &nbsp;&nbsp;<span className={"text-danger coupon-copy"} hidden={true} id={`copy-${i}`}>Coupon Copied to Clipboard!</span>
                                        <hr className={"p-0 m-0"} />
                                    </div>
                                </li>
                            </div>
                        )
                    })
                }
                </div>
            </div>
        );
    }
}
export {Deals};
